module.exports = __webpack_public_path__ + "img/handraw_fraicheur.970db44d.svg";